import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import React from 'react'
import { Button, ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap'

export function PlayerFilter({ choices, onChange, disabled }) {
  const [player, setPlayer] = React.useState(null)

  React.useEffect(() => {
    onChange(player)
  }, [onChange, player])

  return (
    <div className="d-inline-block player-filter m-1">
      <ButtonGroup>
        <DropdownButton
          as={ButtonGroup}
          variant="primary"
          size="sm"
          id="range-filter"
          disabled={disabled}
          title={!player ? 'ALL PLAYERS' : 'PLAYER'}
        >
          <Dropdown.Item active={!player} onClick={() => setPlayer(null)}>
            All Players
          </Dropdown.Item>
          {choices.map(choice => (
            <Dropdown.Item
              key={choice}
              active={player === choice}
              onClick={() => setPlayer(choice)}
            >
              {choice}
            </Dropdown.Item>
          ))}
        </DropdownButton>
        {player && (
          <Button
            variant="secondary"
            disabled={disabled}
            size="sm"
            onClick={() => setPlayer(null)}
          >
            {player}
            <FontAwesomeIcon icon="times" fixedWidth className="ml-2" />
          </Button>
        )}
      </ButtonGroup>
    </div>
  )
}

PlayerFilter.propTypes = {
  disabled: PropTypes.bool,
  choices: PropTypes.array,
  onChange: PropTypes.func,
}

PlayerFilter.defaultProps = {
  disabled: false,
  choices: [],
  onChange: () => {},
}

export default PlayerFilter
